import { render, staticRenderFns } from "./identificationBadgeIdIcon.vue?vue&type=template&id=85145f3a&"
import script from "./identificationBadgeIdIcon.vue?vue&type=script&lang=js&"
export * from "./identificationBadgeIdIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports